import React from "react";
import serviceImages1 from "../assets/images/Professional_Installation.jpg";
import serviceImages2 from "../assets/images/Preventive_Maintenance.jpg";
import serviceImages3 from "../assets/images/Repair_Replacement.jpg";
import serviceImages4 from "../assets/images/Project_Execution.jpg";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import "../assets/css/premiumservices.css"; // Separate CSS file

const services = [
  {
    title: "Professional Installation",
    shortDesc: "Expert setup of all AC brands with precision and care",
    longDesc: "Our certified technicians deliver flawless installation of all air conditioning brands and models. We ensure proper sizing, efficient setup, and meticulous attention to detail for optimal performance and extended equipment lifespan.",
    // icon: "bi-tools",
    image: serviceImages1,
  },
  {
    title: "Preventive Maintenance",
    shortDesc: "Regular check-ups to ensure optimal performance",
    longDesc: "Our comprehensive maintenance plans include thorough cleaning, performance testing, and component inspection. Regular servicing reduces energy costs, prevents breakdowns, and extends your AC system's lifespan by up to 40%.",
    // icon: "bi-shield-check",
    image: serviceImages2,
  },
  {
    title: "Repair & Replacement",
    shortDesc: "24/7 emergency repair services with guaranteed results",
    longDesc: "When your AC fails, our emergency team is available 24/7. We diagnose issues quickly, provide transparent pricing, and offer both repair and replacement options. All our work comes with a 100% satisfaction guarantee.",
    // icon: "bi-wrench-adjustable",
    image: serviceImages3,
  },
  {
    title: "Project Execution",
    shortDesc: "Complete HVAC solutions for commercial projects",
    longDesc: "From initial design to final installation, we handle commercial HVAC projects of any size. Our team works with architects and construction managers to deliver energy-efficient systems that meet your specific business requirements.",
    // icon: "bi-building-gear",
    image: serviceImages4,
  },
];

const PremiumServices = () => {
  return (
    <section id="premium-services" className="premium-services py-5">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="section-title">Our Premium Services</h2>
        </div>

        <div className="row g-4">
          {services.map((service, index) => (
            <div className="col-lg-3 col-md-6" key={index}>
              <div className="service-card h-100">
                <div className="service-image-container">
                  <img 
                    src={service.image} 
                    alt={service.title} 
                    className="service-image img-fluid object-fit-cover" 
                  />
                 
                </div>
                <div className="service-content">
                  <h3 className="service-title fw-bold">{service.title}</h3>
                  <p className="service-short-desc">{service.shortDesc}</p>
                  <div className="service-divider mx-auto"></div>
                  <p className="service-long-desc">{service.longDesc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PremiumServices;